import React from 'react';
import { Box, styled } from '@beeline.com/bp-design-system';

type FadingWrapperProps =
  | {
      gridColumn: string;
      gridRow: string;
    }
  | { absolute: true; className?: string };

export const FadingWrapper = (props: FadingWrapperProps) => {
  if ('absolute' in props) {
    return (
      <Box position="absolute" top={0} left={0} right={0} bottom={0} className={`${props.className} fading-wrapper`}>
        <StyledFading />
      </Box>
    );
  }
  return (
    <Box gridColumn={props.gridColumn} className="fading-wrapper" gridRow={props.gridRow}>
      <StyledFading />
    </Box>
  );
};

const StyledFading = styled('div')`
  pointer-events: none;
  background: linear-gradient(rgba(255, 255, 255, 0), white);
  height: 100%;
  width: 100%;
`;
